<div class="lost-network-connection-container" *ngIf="showNetworkPageFound">
  <img src="assets/mascot/Mascot_connection-failed-Grey@2x.webp" alt="odaring mascot"/>
  <h1 class="heading-8">{{'lost.network.connection.title.1' | translate}}</h1>
  <button type="button" class="btn-refresh" (click)="reload()">{{'button.refresh' | translate}}</button>
</div>
